import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import useSWR, { type SWRConfiguration } from "swr";
import { config } from "@/config";
import type { GetQueries } from "@typings/api";
import { isEmpty } from "@utils/formatters";
import type { GetUsersResponse, UsersFilters } from "./type";

async function getUsers(
  query: GetQueries<UsersFilters>,
): Promise<GetUsersResponse> {
  const params = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (isEmpty(value)) return;

    params.append(key, String(value));
  });

  let url = apiPaths.users.list;
  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  const response = await apiClient.get<GetUsersResponse>(url);

  return response.data;
}

export function useGetUsers(
  query: GetQueries<UsersFilters> | null,
  options?: SWRConfiguration,
) {
  const mergedOptions: SWRConfiguration = {
    ...config.swr,
    ...options,
  };

  return useSWR(
    [`fetch-get-users`, JSON.stringify(query ?? {})],
    () => getUsers(query ?? {}),
    mergedOptions,
  );
}
